import React from "react";
import { Select } from "@murm/ant";
import styles from "./ReusableCombobox.module.css";

const ReusableCombobox = ({
  items,
  selected,
  onSelect,
  displayValue = (item) => item,
  formatOption = (item) => item,
  className = "",
  placeholder = "",
  fillColor,
  isLoading = false,
  allowClear = true,
  ...rest
}) => {
  const options = items.map((item) => ({
    value: item,
    label: formatOption(item),
  }));

  return (
    <Select
      {...rest}
      className={[styles.combobox, className].filter(Boolean).join(" ")}
      value={selected ?? undefined}
      onChange={onSelect}
      options={options}
      placeholder={placeholder}
      showSearch
      filterOption={(input, option) =>
        String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      loading={isLoading}
      allowClear={allowClear}
    />
  );
};

export { ReusableCombobox };
